import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import {
  PiBookmarkSimple,
  PiMapPinLine,
  PiShoppingBag,
  PiStorefront,
} from 'react-icons/pi';
import Fade from 'react-reveal/Fade';
import Section, {
  Content, FeatureGroup,
  FeatureItem, Figure, FigureWrapper, Grid, SectionHeading
} from './experience.style';

const connectIcons = {
  bookmark: PiBookmarkSimple,
  lostFound: PiMapPinLine,
  marketplace: PiShoppingBag,
  services: PiStorefront,
};

const WalletExperience = (props) => {
  const data = useStaticQuery(graphql`
    query {
      appJson {
        walletExperience {
          desc
          features {
            content
            iconName
            id
            title
          }
          slogan
          thumb {
            publicURL
          }
          title
        }
      }
    }
  `);

  const { appJson: walletExperience } = data;

  const wallet = walletExperience?.walletExperience;

  return (
    <Section {...props}>
      <Container width="1400px">
        <Grid>
          <FigureWrapper>
            <Fade up>
              <Figure>
                <Image src={wallet?.thumb?.publicURL} alt="Furbuz Connect — share stories and find pet help" />
              </Figure>
            </Fade>
          </FigureWrapper>
          <Content>
            <SectionHeading>
              <Text className="subtitle" content={wallet?.slogan} />
              <Heading content={wallet?.title} />
              <Text
                className="description"
                content={wallet?.desc}
              />
            </SectionHeading>
            {wallet?.features?.length ?
            <FeatureGroup>
              {wallet?.features?.map((feature) => {
                const ConnectIcon = connectIcons[feature?.iconName] || PiChatCircleDots;
                return (
                  <FeatureItem key={feature?.id}>
                    <figure aria-hidden="true">
                      <ConnectIcon />
                    </figure>
                    <div>
                      <Heading as="h3" content={feature?.title} />
                      <Text
                          className="description"
                          content={feature?.content}
                      />
                    </div>
                  </FeatureItem>
                )
              })}
            </FeatureGroup>
            :
            ""
            }
          </Content>
        </Grid>
      </Container>
    </Section>
  );
};

export default WalletExperience;
